/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-23 12:09:57
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 10:32:02
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/GuestCheckoutOption/index.tsx
 */
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import React from 'react';
import { RadioGroup, RadioItem } from 'src/components/Antd';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const CheckoutOption = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, setHasModified, disableEdit } = props;
  const handleOnOptionChange = (e) => {
    const enabled = e.target.value;
    onChange(enabled);
    setHasModified(true);
  };
  return (
    <SectionWrapper
      title={getI18n('salesChannelCheckout.index.guestCheckoutOption')}>
      <ItemWrapper
        bottomTitleContainerClassName={css.bottomTitleContainerClassName}
        title={getI18n('salesChannelCheckout.index.guestCheckout')}
        bottomTitle={getI18n('salesChannelCheckout.index.guestCheckoutTip')}>
        <RadioGroup
          value={data}
          onChange={handleOnOptionChange}
          className={css.radioGroup}
          disabled={disableEdit}>
          <RadioItem value={false} className={css.radio}>
            {getI18n('general.disabled')}
          </RadioItem>
          <RadioItem value={true}>{getI18n('general.enabled')}</RadioItem>
        </RadioGroup>
      </ItemWrapper>
    </SectionWrapper>
  );
};
export default CheckoutOption;
